import { render, staticRenderFns } from "./Welders.vue?vue&type=template&id=78ed69d6"
import script from "./Welders.vue?vue&type=script&lang=js"
export * from "./Welders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports